(function($) {

    $(document).ready(function() {
$(".animsition").animsition({
     inClass: 'fade-in-down-sm',
    outClass: 'fade-out-down-sm',
    // inClass: 'fade-in-up-sm',
    // outClass: 'fade-out-up-sm',
    inDuration: 1500,
    outDuration: 800,
    linkElement: '#footer .footer-col nav ul li a',
    // e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
    loading: true,
    loadingParentElement: 'body', //animsition wrapper element
    loadingClass: 'animsition-loading',
    loadingInner: '', // e.g '<img src="loading.svg" />'
    timeout: false,
    timeoutCountdown: 5000,
    onLoadEvent: true,
    browser: [ 'animation-duration', '-webkit-animation-duration'],
    // "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
    // The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
    overlay : false,
    overlayClass : 'animsition-overlay-slide',
    overlayParentElement : 'body',
    transition: function(url){ window.location.href = url; }
  });
});


    // ALL

    if ('loading' in HTMLImageElement.prototype) {
        const images = document.querySelectorAll('img[loading="lazy"]');
        images.forEach(img => {
            img.src = img.dataset.src;
        });
    } else {
        // Dynamically import the LazySizes library
        const script = document.createElement('script');
        script.src =
            'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.2/lazysizes.min.js';
        document.body.appendChild(script);
    }


    // PLACEHOLDER
    $('input,textarea').focus(function() {
        $(this).data('placeholder', $(this).attr('placeholder'))
        .attr('placeholder', '');
        }).blur(function() {
        $(this).attr('placeholder', $(this).data('placeholder'));
    });


    // MENU SIZE - SCROLL DOWN
    var menu = $('body').offset().top + 100
    if ($(window).width() > 992) {

        $(window).scroll(function() {
            if ($(this).scrollTop() >= menu) {
                $('.navbar__fixed').addClass('navbar__fixed--small');
                $('.mobile-overlay').addClass('mobile-overlay--scroll');
            } else {
                $('.navbar__fixed').removeClass('navbar__fixed--small');
                $('.mobile-overlay').removeClass('mobile-overlay--scroll');
            }
        });
    }

    // HEIGHT

    $(window).on('load',function(){

    // get the maxHeight using innerHeight() function
      var maxHeight = Math.max.apply(null, $(".single-parquet-list ul li h2").map(function ()                                                        {
        return $(this).innerHeight();
      }).get());
      
    // Set the height to all .panel elements
      $(".single-parquet-list ul li h2").height( maxHeight );
      
    });

    // SHOW IMG 
    function showImages(el) {
        var windowHeight = jQuery( window ).height();
        $(el).each(function(){
            var thisPos = $(this).offset().top;

            var topOfWindow = $(window).scrollTop();
            if (topOfWindow + windowHeight - 200 > thisPos ) {
                $(this).addClass("fadeIn");
            }
        });
    }

    // if the image in the window of browser when the page is loaded, show that image
    $(document).ready(function(){
        showImages('.aniImg');
    });

    // if the image in the window of browser when scrolling the page, show that image
    $(window).scroll(function() {
        showImages('.aniImg');
    });


     // HAMBURGER
    $('.hamburger').on('click', function() {
        $(this).toggleClass('open-h');
        $('body, html').toggleClass('menu-open');
        $('.mobile-overlay').stop().slideToggle().delay(300).toggleClass('open-m');
    });

    $('.mobile-overlay .menu li ul li a').on("click", function(){
    $('.mobile-overlay').stop().slideUp();
    $('.hamburger').toggleClass('open-h');
    });


    // BUTTONS
    $(document).on('click', '#btn-next', function() {
        $('html, body').animate({
            scrollTop: $("#next").offset().top - 50
        }, 750);
        return false
    });

    var h = $('.team-list .grid li a .foto').height();
    $('.team-list .grid li:last-child a').css({height: h});



    // SPECJALIZACJE TABS

    $('.specializations-list-loop-foto .foto').hide();
    $('.specializations-list-loop-foto .foto:first').show();
        
    $('.specializations-list-loop ul li a').hover(function(){
        var t = $(this).attr('id');        
        $('.specializations-list-loop-foto .foto').hide();
        $('#'+ t + 'F').show();
    });

    // APLA SPECJALIZACJE I ZESPOL

    $('.home-specializations .apla, .team-person .apla, .specializations-last-post .apla').hide();
    $('.home-specializations ul li a, .team-person ul li a, .specializations-last-post ul li a').hover(function(){
        var t = $(this).attr('id');        
        $('#'+ t + 'F').show();
        }, function(){
        var t = $(this).attr('id');  
        $('#'+ t + 'F').hide();
    });
    

    // SLIDER HOME
    $('.home-slider-cnt .row').hover(function(){
        $('body').addClass('slider_on');
        }, function(){
        $('body').removeClass('slider_on');
    });

    
}(jQuery));